// @flow
import type { Params, Available } from 'app/common/components/Cafeteria/dataTypes/orderRequests/Available.types';

import type { Request } from '../../../index';


const dateFormatParamsApi = 'YYYY-MM-DD';

type ApiParams = {
  date: string,
  customer_id: number,
}

export const convertParams = ({ customerId, date }: Params): [ApiParams, null] => {
  return [{
    date: date.getString(dateFormatParamsApi),
    customer_id: parseInt(customerId, 10),
  }, null];
};

type ResultApi = {
  klass_order_available_on: string,
  day_care_order_available_on: string,
}

export const convertResult = ({
  klass_order_available_on: klass,
  day_care_order_available_on: dayCare,
}: ResultApi = {}): Available => {
  const klassOrderAvailable = parseFloat(klass);
  const dayCareOrderAvailable = parseFloat(dayCare);

  return ({
    klassOrderAvailable: Number.isNaN(klassOrderAvailable) ? null : klassOrderAvailable,
    dayCareOrderAvailable: Number.isNaN(dayCareOrderAvailable) ? null : dayCareOrderAvailable,
  });
};

export const GET_CAFETERIA_CUSTOMER_ORDERS_AVAILABLE: Request<
  Params,
  Available,
  void
> = [
  'cafeteria/customer/orders/available',
  'get',
  ['data'],
];
